import EditCategoryForm from './EditCategoryForm';
import LaunchdeckModal from '../../global/components/helper-components/components/LaunchdeckModal';


export default function EditCategoryModal({ showModal, mapCategoryId, categoryToEdit, handleCloseModal, dsrId }) {
  return (
    <LaunchdeckModal
      title='Edit category'
      handleCloseModal={handleCloseModal}
      showModal={showModal}
      maxW='35em'
    >
      <EditCategoryForm
        dsrId={dsrId}
        mapCategoryId={mapCategoryId}
        categoryToEdit={categoryToEdit}
        handleCloseModal={handleCloseModal}
      />
    </LaunchdeckModal>
  )
}
